import { getAllowedFAQBreadcrumb } from '../metadata-helpers';

export const getBrowseSearchStructuredData = ({ canonical, skus, title, breadcrumbs }) => {
  if (breadcrumbs && breadcrumbs.length && breadcrumbs?.[0]?.label !== 'Home') {
    breadcrumbs.unshift({ label: 'Home', url: '' });
  }
  return {
    '@type': 'WebPage',
    name: title,
    url: canonical,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: (breadcrumbs || []).map(({ label, url }, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Thing',
          name: label,
          '@id': `https://www.homedepot.com${url}`,
        },
      })),
    },
    mainEntity: {
      '@type': 'WebPageElement',
      offers: {
        '@type': 'Offer',
        itemOffered: (skus || [])
          .map((sku) => (sku.toJSON ? sku.toJSON() : sku))
          .map(({
            identifiers = {},
            reviews = {},
            pricing = {},
            media = {}
          }) => ({
            '@type': 'Product',
            ...(Number(reviews?.ratingsReviews?.totalReviews) && {
              aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: reviews?.ratingsReviews?.averageRating,
                reviewCount: reviews?.ratingsReviews?.totalReviews,
                bestRating: '5',
                worstRating: '1',
              },
            }),
            brand: {
              '@type': 'Thing',
              name: identifiers.brandName,
            },
            description: identifiers.productLabel,
            image: media.images?.[0]?.url?.replace('<SIZE>', '100'),
            name: identifiers.productLabel,
            offers: {
              '@type': 'Offer',
              availability: 'http://schema.org/InStock',
              price: pricing?.value,
              priceCurrency: 'USD',
              url: `https://www.homedepot.com${identifiers.canonicalUrl}`,
            },
            sku: identifiers.itemId
          })),
      },
    },
    '@context': 'http://schema.org',
  };
};

export const getBrowseSearchFAQStructuredData = ({
  canonical, skus, title, breadcrumbs, faq
}) => {
  if (breadcrumbs && breadcrumbs.length && breadcrumbs?.[0]?.label !== 'Home') {
    breadcrumbs.unshift({ label: 'Home', url: '' });
  }
  return {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    name: title,
    url: canonical,
    mainEntity: faq,
    ...(getAllowedFAQBreadcrumb(canonical) && { breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: (breadcrumbs || []).map(({ label, url }, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Thing',
          name: label,
          '@id': `https://www.homedepot.com${url}`,
        },
      })),
    } }),
    // offers: {
    //   '@type': 'Offer',
    //   itemOffered: (skus || [])
    //     .map((sku) => (sku.toJSON ? sku.toJSON() : sku))
    //     .map(({
    //       identifiers = {},
    //       reviews = {},
    //       pricing = {},
    //       media = {}
    //     }) => ({
    //       '@type': 'Product',
    //       ...(Number(reviews?.ratingsReviews?.totalReviews) && {
    //         aggregateRating: {
    //           '@type': 'AggregateRating',
    //           ratingValue: reviews?.ratingsReviews?.averageRating,
    //           reviewCount: reviews?.ratingsReviews?.totalReviews,
    //           bestRating: '5',
    //           worstRating: '1',
    //         },
    //       }),
    //       brand: {
    //         '@type': 'Thing',
    //         name: identifiers.brandName,
    //       },
    //       description: identifiers.productLabel,
    //       image: media.images?.[0]?.url?.replace('<SIZE>', '100'),
    //       name: identifiers.productLabel,
    //       offers: {
    //         '@type': 'Offer',
    //         availability: 'http://schema.org/InStock',
    //         price: pricing?.value,
    //         priceCurrency: 'USD',
    //         url: `https://www.homedepot.com${identifiers.canonicalUrl}`,
    //       },
    //       sku: identifiers.itemId
    //     })),
    // },

  };
};
